import { useEffect, useState } from "react";
import SegmentControl from "Components/Sales/SegmentControl";
import SalesCalendarTab from "Components/Sales/SalesCalendarTab";
import SalesTrendTab from "Components/Sales/SalesTrendTab";
import SalesBreakdownTab from "Components/Sales/SalesBreakdownTab";
import SalesCustomersTab from "Components/Sales/SalesCustomersTab";
import SalesTagManageModal from "Components/Sales/SalesTagManageModal";
import useSalesFilter, { SALES_TABS } from "utils/useSalesFilter";

const TAB_LABELS = {
  calendar: "달력",
  trend: "추이",
  breakdown: "비중",
  customers: "고객",
};

const SERVICE_OPTIONS = [
  { key: "all", label: "전체" },
  { key: "trademark", label: "상표" },
  { key: "patent", label: "특허" },
  { key: "design", label: "디자인" },
  { key: "other", label: "기타" },
];

const styles = {
  container: {
    padding: "32px 40px",
    backgroundColor: "#f1f5f9",
    minHeight: "100vh",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    flexWrap: "wrap",
    marginBottom: "20px",
  },
  title: {
    fontSize: "24px",
    fontWeight: "700",
    color: "#1f2937",
    margin: 0,
  },
  serviceRow: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  serviceLabel: {
    fontSize: "13px",
    color: "#6b7280",
  },
  tabRow: {
    display: "flex",
    gap: "4px",
    marginBottom: "24px",
    borderBottom: "2px solid #e5e7eb",
  },
  tabBtn: {
    padding: "10px 20px",
    fontSize: "15px",
    fontWeight: "600",
    border: "none",
    backgroundColor: "transparent",
    color: "#6b7280",
    cursor: "pointer",
    borderBottom: "2px solid transparent",
    marginBottom: "-2px",
    fontFamily: "inherit",
  },
  tabBtnActive: {
    color: "#2563eb",
    borderBottom: "2px solid #2563eb",
  },
  tabSpacer: { flex: 1 },
  tagBtn: {
    alignSelf: "center",
    marginBottom: "6px",
    padding: "7px 12px",
    fontSize: "13px",
    fontWeight: "500",
    border: "1px solid #d1d5db",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
    color: "#4b5563",
    cursor: "pointer",
    fontFamily: "inherit",
  },
};

const SalesDashboard = () => {
  const { tab, service, year, month, updateParams } = useSalesFilter();
  const [showTagModal, setShowTagModal] = useState(false);
  const [tagVersion, setTagVersion] = useState(0);

  useEffect(() => {
    document.title = "마크픽 관리자 > 매출 관리";
  }, []);

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>매출 관리</h1>
        <div style={styles.serviceRow}>
          <span style={styles.serviceLabel}>서비스</span>
          <SegmentControl
            options={SERVICE_OPTIONS}
            value={service}
            onChange={(key) => updateParams({ service: key, page: null })}
          />
        </div>
      </div>

      <div style={styles.tabRow} role="tablist">
        {SALES_TABS.map((key) => (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={tab === key}
            style={{ ...styles.tabBtn, ...(tab === key ? styles.tabBtnActive : {}) }}
            onClick={() => updateParams({ tab: key, page: null })}
          >
            {TAB_LABELS[key]}
          </button>
        ))}
        <span style={styles.tabSpacer} />
        <button type="button" style={styles.tagBtn} onClick={() => setShowTagModal(true)}>태그 관리</button>
      </div>

      {tab === "calendar" && (
        <SalesCalendarTab key={tagVersion} year={year} month={month} service={service} updateParams={updateParams} />
      )}
      {tab === "trend" && <SalesTrendTab service={service} />}
      {tab === "breakdown" && <SalesBreakdownTab key={tagVersion} service={service} />}
      {tab === "customers" && <SalesCustomersTab key={tagVersion} service={service} />}

      {showTagModal && (
        <SalesTagManageModal
          onClose={() => setShowTagModal(false)}
          onChanged={() => setTagVersion((v) => v + 1)}
        />
      )}
    </div>
  );
};

export default SalesDashboard;
